import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@hooks';
import { Button } from '@ui';

export const LogOutButton = () => {
    const store = useStore();
    const navigate = useNavigate();
    const { logout } = store.authStore;

    const handleLogoutClick = async () => {
        await logout();
        navigate('/');
    };

    return (
        <Button type='link' onClick={handleLogoutClick}>
            Sign out
        </Button>
    );
};
